import { styled } from '@ori-ui/mui';
import React from 'react';

import { useAppContext } from '../../contexts';

interface NotifyNonCumulusProps {
    productCode: string;
}

const PRODUCT_CODE_PARAM = 'prodCode';
const CODE_PARAM = 'code';

const Root = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    height: 250,
    [theme.breakpoints.up(768)]: {
        width: 350,
    },
}));

const StyledIframe = styled('iframe')({
    flexGrow: 1,
});

export const NotifyNonCumulus: React.FC<NotifyNonCumulusProps> = ({ productCode }) => {
    const { notifyMeSubscriptionConfiguration } = useAppContext();
    const parseUrl = new URL(notifyMeSubscriptionConfiguration.NonCumulusIframeSrc);

    parseUrl.searchParams.set(PRODUCT_CODE_PARAM, productCode);
    parseUrl.searchParams.set(CODE_PARAM, productCode);

    return (
        <Root>
            <StyledIframe title={productCode} src={parseUrl.toString()} />
        </Root>
    );
};
